import { Link } from "react-router-dom";
import { Check, X, ArrowRight, Shield } from "lucide-react";

export const ComparisonSection = () => {
  const comparisons = [
    {
      title: "PDFWorkSpace",
      highlight: true,
      icon: Shield,
      features: [
        { text: "Runs 100% in your browser", positive: true },
        { text: "No uploads, ever", positive: true },
        { text: "No accounts required", positive: true },
        { text: "Free and unlimited", positive: true },
        { text: "Works offline", positive: true },
      ],
    },
    {
      title: "Online PDF Sites",
      highlight: false,
      features: [
        { text: "Require file uploads", positive: false },
        { text: "May log your files", positive: false },
        { text: "Often need accounts", positive: false },
        { text: "Free tiers are limited", positive: false },
        { text: "Need internet connection", positive: false },
      ],
    },
    {
      title: "Desktop Software",
      highlight: false,
      features: [
        { text: "Need installation", positive: false },
        { text: "Require licenses", positive: false },
        { text: "Heavy resource usage", positive: false },
        { text: "Updates can be slow", positive: false },
        { text: "May not be allowed at work", positive: false },
      ],
    },
  ];

  return (
    <section className="bg-background py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4">
        {/* Section Header */}
        <div className="mb-12 flex flex-col items-center text-center">
          <span className="mb-4 inline-block rounded-full bg-secondary px-4 py-1.5 text-xs font-medium uppercase tracking-wider text-text-secondary">
            Comparison
          </span>
          <h2 className="font-serifAccent text-3xl tracking-tight text-foreground md:text-4xl">
            Why choose PDFWorkSpace?
          </h2>
          <p className="mt-3 max-w-lg text-md text-text-secondary">
            See how we compare to other PDF solutions.
          </p>
        </div>

        {/* Comparison Cards */}
        <div className="grid gap-6 md:grid-cols-3">
          {comparisons.map((item, index) => (
            <div
              key={item.title}
              className={`relative rounded-2xl border p-6 transition-all duration-300 opacity-0 animate-fade-in-up ${
                item.highlight
                  ? "border-foreground bg-card shadow-lg scale-[1.02]"
                  : "border-border bg-card/50 hover:border-border/80"
              }`}
              style={{ animationDelay: `${0.1 + index * 0.1}s` }}
            >
              {/* Best Choice Badge */}
              {item.highlight && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-foreground px-4 py-1 text-xs font-semibold text-background">
                  Best Choice
                </div>
              )}

              {/* Title */}
              <div className="mb-6 flex items-center gap-3">
                {item.icon && (
                  <div className="rounded-lg bg-foreground p-2 text-background">
                    <item.icon className="h-5 w-5" />
                  </div>
                )}
                <h3
                  className={`text-lg font-semibold ${item.highlight ? "text-foreground" : "text-text-secondary"}`}
                >
                  {item.title}
                </h3>
              </div>

              {/* Features List */}
              <ul className="space-y-3">
                {item.features.map((feature) => (
                  <li key={feature.text} className="flex items-start gap-3">
                    {feature.positive ? (
                      <div className="mt-0.5 rounded-full bg-green-500/10 p-1">
                        <Check className="h-3.5 w-3.5 text-green-600" />
                      </div>
                    ) : (
                      <div className="mt-0.5 rounded-full bg-foreground/5 p-1">
                        <X className="h-3.5 w-3.5 text-text-secondary/50" />
                      </div>
                    )}
                    <span
                      className={`text-sm ${feature.positive ? "text-foreground" : "text-text-secondary"}`}
                    >
                      {feature.text}
                    </span>
                  </li>
                ))}
              </ul>

              {/* CTA for highlighted card */}
              {item.highlight && (
                <Link
                  to="/tools"
                  className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-foreground py-3 text-sm font-medium text-background transition-all hover:bg-foreground/90"
                >
                  Get started free
                  <ArrowRight className="h-4 w-4" />
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
